<template>
  <div class="login-page">
    <div class="card">
      <h1>Bienvenue</h1>
      <p>Connectez-vous pour gérer vos Audio-Buttons</p>

      <div class="btn-container">
        <GoogleSignInButton
          @error="handleLoginError"
          @success="handleLoginSuccess"
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>

  import { type CredentialResponse, GoogleSignInButton } from 'vue3-google-signin'
  import { useRoute } from 'vue-router'
  import { authRepository } from '@/api/repository/auth.repository.ts'
  import router from '@/router'
  import { useAuthStore } from '@/stores/auth.ts'

  const authStore = useAuthStore()
  const route = useRoute()

  async function handleLoginSuccess (response: CredentialResponse) {
    console.log('handleLoginSuccess...')
    const token = response.credential

    if (!token) {
      console.error('No credential received from Google')
      return
    }

    try {
      const data = await authRepository.loginWithGoogle(token)
      authStore.login(data.sessionToken, data.user)

      // Redirect the user to the dashboard or the requested page
      const redirectPath = route.query.redirect as string
      await (redirectPath ? router.push(redirectPath) : router.push({ name: 'root' }))
    } catch (error) {
      console.error('Backend authentication failed', error)
      alert('Erreur lors de la connexion au serveur.')
    }
  }

  /**
   * Handle initialization or execution errors from Google SDK
   */
  function handleLoginError () {
    alert('La connexion Google a échoué.')
  }
</script>

<style scoped>
.login-page {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 70vh;
  padding: 1rem;
}

.card {
  background: white;
  padding: 2.5rem;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  text-align: center;
  max-width: 400px;
  width: 100%;
}

.btn-container {
  margin-top: 2rem;
  display: flex;
  justify-content: center;
}

@media (max-width: 600px) {
  .login-page {
    min-height: 60vh;
    align-items: flex-start;
    padding-top: 2rem;
  }

  .card {
    padding: 1.5rem;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  }
}
</style>
